export default "__VITE_ASSET__HyKA0SO6__"